export const CHART_COLORS = [
  '#0040FF', '#00B050', '#FF8C00', '#DB4F4F', '#7B2D8E',
  '#00A5A8', '#FFB020', '#E91E90', '#607D8B', '#3F51B5'
];

export const ROWS_PER_PAGE = 200;
export const CHART_MAX_ROWS = 1000;
